import styled from "styled-components";

import ArrowCarousel from "src/components/Icons/Glyphs/ArrowCarousel";

import { arrowCarouselPosition } from "./ShopCarousel.types";

export const ShopCarouselSliderArrow = styled.div<arrowCarouselPosition>`
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  position: absolute;
  opacity: 0.5;
  top: calc(50% - 20px);
  z-index: 100;
  cursor: pointer;
  ${({ isRight }): string =>
    isRight
      ? "right: 0; transform: translateX(-30px)"
      : "left: 0; transform: translateX(30px)"};
  @media screen and (min-width: 770px) {
    &:hover {
      opacity: 0.65;
    }
  }
  @media screen and (max-width: 767px) {
    top: calc(50% - 14px);
    ${({ isRight }): string =>
      isRight ? "transform: translateX(-30px)" : "transform: translateX(30px)"};
    width: 28px;
    height: 28px;
      }
    }};
  }
`;

export const InnerArrow = styled(ArrowCarousel)<arrowCarouselPosition>`
  width: 18px;
  height: 18px;

  ${({ isRight }): string =>
    isRight
      ? `
    transform: rotate(180deg);
    `
      : ""}

  @media (max-width: 767px) {
    width: 12x;
    height: 12px;
  }
`;
